import './Homepage.css';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import Recap from '../../components/Recap';

function Homepage() {
  return (
    <div className="HomePage">
      <Navbar />
      <Recap />
      <Footer />
    </div>
  );
}

export default Homepage;
